<template>
  <a-locale-provider :locale="hu_HU">
    <div id="app">
      <router-view></router-view>
    </div>
  </a-locale-provider>
</template>

<script>
import hu_HU from 'ant-design-vue/lib/locale-provider/hu_HU';
import FadeTransition from '@/transitions/FadeTransition.vue';

export default {
  components: {
    FadeTransition
  },
  
  data() {
    return {
      hu_HU
    }
  },

  
}

</script>

<style lang="scss">
  .primary-blue-bg {
    background-color: $primary-blue;
  }
  html {
    scroll-behavior: smooth
  }
  div.ant-card-meta-title {
    white-space: normal;
  }
</style>
